import { ADMIN_URLS } from "../../apiConfig.js";
import { USER_ERRORS } from "../../../common/constants/adminModule/userConstants.js";
import apiClient from "../../apiInstance";

export const getUsers = async () => {
    try {
        const response = await apiClient.get(ADMIN_URLS.FETCH_USERS);
        return response.data;
    } catch (error) {
        console.error(USER_ERRORS.FETCH_USERS, error);
        throw error;
    }
};

export const addUser = async (userData) => {
    try {
        const response = await apiClient.post(`${ADMIN_URLS.ADD_USER}`, userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error(USER_ERRORS.ADD_USER_ERROR, error);
        throw error;
    }
};

export const editUser = async (user) => {
    try {
        const response = await apiClient.put(`${ADMIN_URLS.EDIT_USER}`, user);
        return response.data;
    } catch (error) {
        console.error(USER_ERRORS.UPDATE_USER_ERROR, error);
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
        const response = await apiClient.put(`${ADMIN_URLS.DELETE_USER}/${userId}`);
        return response.data;
    } catch (error) {
        console.error(USER_ERRORS.DELETE_USER_ERROR, error);
        throw error;
    }
};
